import { render, staticRenderFns } from "./SysMessageTemplateModal.vue?vue&type=template&id=4a6dc917&scoped=true&"
import script from "./SysMessageTemplateModal.vue?vue&type=script&lang=js&"
export * from "./SysMessageTemplateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6dc917",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a6dc917')) {
      api.createRecord('4a6dc917', component.options)
    } else {
      api.reload('4a6dc917', component.options)
    }
    module.hot.accept("./SysMessageTemplateModal.vue?vue&type=template&id=4a6dc917&scoped=true&", function () {
      api.rerender('4a6dc917', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/message/modules/SysMessageTemplateModal.vue"
export default component.exports